<template>
    <div class="body">
      <section class="my_userInfo">
        <div class="top_box">
            <div class="topLeft">
                <img class="my_userMessage_right_icon" :src="common.userInfo.photoPath?common.userInfo.photoPath:require(`../../../assets/images/img_default_face_${common.theme}.jpg`)"
                alt="头像"
                @click="toSetting"/>
                <span class="my_userMessage_left_span1" @click="toSetting">{{common.userTenantInfo.userName?common.userTenantInfo.userName:(common.userInfo.userName?common.userInfo.userName:'未登录')}}</span>
            </div>
            <div class="topRight">
                <div class="TopView_saoma" @click="saomaAction()">
                    <img :src="require(`../../../assets/images/themes_my/icon_my_saoma_${common.theme}.png`)" alt="">
                  </div>
                  <div class="TopView_message" @click="toMessage">
                    <span class="point" v-if="showPoint"></span>
                    <img :src="require(`../../../assets/images/themes_my/icon_my_message_${common.theme}.png`)" alt="">
                  </div>
            </div>
        </div>
        <template v-if="common.userId">
            <div class="integral_box">
                <div class="my_userMessage_left_div" @click="toIntegralMall">
                    <div class="integral_left_div">
                        <span class="my_userMessage_left_span3">{{integration}}</span>
                        <span class="my_userMessage_left_span2">积分</span>
                    </div>
                    <img class="my_userMessage_left_icon" src="../../../assets/images/icon_indicator_next.png"/>
                </div>
            </div>

            <template v-if="defaultTenant.company">
                <div class="companyDiv" @click="toCompanyList">
                    <div class="company_left">
                        <img class="company_left_icon" src="../../../assets/images/me/my_icon_rectangle.png"/>
                        <img class="company_left_icon1" src="../../../assets/images/me/my_icon_rectangle1.png"/>
                    </div>
                    <div class="company_right">
                        <div class="company_right_div1">
                            <span class="company_right_company_span">{{defaultTenant.company}}</span>
                            <img class="company_right_company_icon" src="../../../assets/images/me/whiteArrow.png" />
                        </div>
                        <div class="company_right_div2">
                            <span class="company_right_company_span">{{level}}</span>
                        </div>
                    </div>

                </div>


            </template>
            <section class="login_n" @click="toCompanyList" v-if="common.userId && !defaultTenant.company" >
                <img
                  :src="require(`../../../assets/images/img_my_identify_${common.theme}.jpg`)"
                  alt=""
                />
            </section>


        </template>


        <!-- <img class="my_header_pic" :src="require(`../../../assets/images/themes_my/img_my_bg_${common.theme}.jpg`)" alt=""> -->
        <!-- <div class="top_box">
          <div class="TopView" >
              <div class="TopView_saoma" @click="saomaAction()">
                <img :src="require(`../../../assets/images/themes_my/icon_my_saoma_${common.theme}.png`)" alt="">
              </div>
              <div class="TopView_message" @click="toMessage">
                <span class="point" v-if="showPoint"></span>
                <img :src="require(`../../../assets/images/themes_my/icon_my_message_${common.theme}.png`)" alt="">
              </div>
          </div>
          <div class="my_userMessage" >
            <div class="my_userMessage_left" v-if="!common.userId" @click="toLogin" >
                <span class="my_userMessage_left_span1" >未登录</span>
                <div class="my_userMessage_left_div" >
                  <span class="my_userMessage_left_span2">点击登录，体验更多功能~</span>
                </div>
            </div>
            <div class="my_userMessage_left" v-else >
                <span class="my_userMessage_left_span1" @click="toSetting">{{common.userTenantInfo.userName?common.userTenantInfo.userName:(common.userInfo.userName?common.userInfo.userName:'未登录')}}</span>
                <div class="my_userMessage_left_div" @click="toIntegralMall">
                  <span class="my_userMessage_left_span2">积分：</span>
                  <span class="my_userMessage_left_span3">{{integration}}</span>
                  <img class="my_userMessage_left_icon" src="../../../assets/images/icon_indicator_next.png"/>
                </div>
            </div>
            <div class="my_userMessage_right">
                <img class="my_userMessage_right_icon" :src="common.userInfo.photoPath?common.userInfo.photoPath:require(`../../../assets/images/img_default_face_${common.theme}.jpg`)"
              alt="头像"
              @click="toSetting"/>
            </div>
          </div>
          <div class="my_user_company" v-if="common.userId && defaultTenant.company" >
                <div class="my_user_company_bg" @click="toCompanyList">
                  <img class="my_user_company_icon" src="../../../assets/images/icon_mycompany_passed.png" />
                  <span class="my_user_company_span">{{defaultTenant.company}}</span>
                  <img class="my_user_company_img" src="../../../assets/images/icon_indicator_next.png" />
                </div>
          </div>
          <div class="my_user_bottom" ></div>
          <div class="my_user_huiyuan" v-if="common.userId && level &&levelBgStyle" >
            <img class="my_user_huiyuan_img1"  :src="levelBgStyle"/>
            <span class="my_user_huiyuan_span">{{level}}</span>
          </div>
          <div class="my_user_huiyuan" v-else-if="common.userId " >
            <img class="my_user_huiyuan_img"  src="../../../assets/images/pt_ka.png"/>
          </div>
        </div> -->
      </section>
      <!-- <section class="login_n" @click="toCompanyList" v-if="common.userId && !defaultTenant.company" >
        <img
          :src="require(`../../../assets/images/img_my_identify_${common.theme}.jpg`)"
          alt="头像"
        />
      </section> -->
    </div>
  </template>

  <script>
  import { verificationCode,writeOff,getShareInfo } from "../../../utils/api";
  import wx from 'weixin-js-sdk'
  //import wx from 'jweixin-1.6.0'
  import util from "../../../utils/util";
  export default {
    name: "meHeader",
    props: {
      integration:{
        type:Number,
        default: 0
      },
      level:{
        type:String,
        default:'',
      },
      levelBgStyle:{
        type:String,
        default:'',
      },
      common: {
        type: Object,
        default() {
          return {};
        }
      },
      showPoint: {
        type: Boolean,
        default: false
      }
    },
     data() {
      return {
        ShareInfo:'',
      }
    },
    computed: {
      defaultTenant() {
        let data = this.common.userTenantInfoList || [];
        let defaultD = {};
        data.forEach(item => {
          if (item.isDeafult == 1) {
            defaultD = item;
          }
        });
        return defaultD;
      }
    },
    methods: {
      toIntegralMall(){
        this.$router.push({
            path:'/IntegralMall'
          })
      },
      //打开微信扫一扫
      saomaAction(){
            // var data ={"actId":"051504B6D4DE4C3790E6C20D7946FDAA"}
            //     // "orderNo":"HO2201911060002",
            // // "userId":"FB6DE3CDB198473DA6A4A9F45376D354",
            // // "orderType":0}
            // if(data){
            //   this.hexiaoAction(data);
            //   return;
            // }
            //util.showToast("首先确认按钮被点到了",1000);

            var that =this;
            if (!this.$store.state.common.userId) {  //未登录
                // util.showToast("请先登录")
                this.$router.push({
                    path: "/login",
                });
              return;
            }
             let u = window.navigator.userAgent;
            if(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 ){
                wx.config({
                    debug: false,
                    appId: this.ShareInfo.appid, // 必填，公众号的唯一标识
                    timestamp: this.ShareInfo.timestamp, // 必填，生成签名的时间戳，精确到秒
                    nonceStr: this.ShareInfo.nonceStr, // 必填，生成签名的随机串
                    signature: this.ShareInfo.signature, // 必填，签名
                    jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','updateAppMessageShareData','updateTimelineShareData','chooseImage', 'uploadImage','downloadImage','chooseWXPay','checkJsApi', 'scanQRCode','hideMenuItems','hideOptionMenu','getLocation']
                  })
            }
           //  console.log(" error")
             wx.error(function(res){
                   console.log('in error  '+ JSON.stringify(res) );
             });
            // console.log(" ready")
            wx.ready(()=>{
                 console.log(" in  ready")
                  wx.checkJsApi({
                      jsApiList: ['scanQRCode'],
                      success: function (res) {
                         console.log('in checkJsApi   '+JSON.stringify(res));
                      },
                      fail: function (res) {
                        // util.showToast("错误信息== fail    " + JSON.stringify(res),20000);
                         console.log('in checkJsApi fail  '+JSON.stringify(res));
                      },
                  });
                  wx.scanQRCode({
                      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                      scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
                      success: function (res) {
                          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                          console.log("扫码结果== "+ result);
                          if(result.indexOf("grantId") > -1){
                            var grantId =result.split(":")[1];
                            that.writeOffYq(grantId)
                            return;
                          }else if(result.indexOf(":")==-1 && result.length==32){
                            that.hexiaoAction(result)
                            return;
                          
                          }else if(result.indexOf("getQRParkingCoupon")> -1){
                          // https://t-ics-mapi.spaceup.com.cn/getQRParkingCoupon?marketId=175&scene=c229aa285059447ea5be526cb40fcff3
                            that.goToGetQRParkingCoupon(result)
                          return;
                          }
                          try {
                            var result1 = JSON.parse(result)
                            if( result1.devSn){ //开门
                                console.log("扫码开门")
                            }else if(result1.actId){
                            // {"actId":"A8453087FB784982AE19BFBDDD5C743B","orderNo":"HO2201911060001","userId":"0E3991CEC4DA4E1AA635990450322EFB","orderType":0}
                                that.hexiaoAction(result1);
                            }else{
                                util.showToast("无效的二维码");
                            }
                          }catch(e) {
                                util.showToast("无效的二维码");
                          }
                      },
                      cancel: function (res) {
                         console.log('错误信息1== cancel  '+JSON.stringify(res));
                      },
                      error:function(res){
                         console.log('错误信息1== error   '+JSON.stringify(res));
                      },
                      fail:function(res){
                          // util.showToast("错误信息1== fail    " + JSON.stringify(res),20000);
                          console.log('错误信息1== error   '+JSON.stringify(res));
                       }

                  });
              });
      },
      writeOffYq(grantId){
        let params = {
          grantId:grantId,
          phone:this.common.userInfo.phone || this.common.userInfo.account
        }
        writeOff(params).then(res=>{
          console.log(res)
          if(res.res.code == 10000){
            this.$router.push(`/successPage?title=扫码成功&desc=请领取测温手环后进入`)
          }else{
            util.showModal('', '您不在今日现场办公名单里，请与贵司行政部门联系。', false, '我知道了');
          }
        })
      },
      hexiaoAction(param){
           var  params = {
             "userId":this.common.userId,
              "cityId":this.common.marketInfo.cityId,
              "marketId":this.common.marketInfo.id,
              "userName":this.common.userInfo.userName,
              "phone":this.common.userInfo.account,
               sourceType:2, //固定值 来源h5
               "data":param
            };

            verificationCode (params).then(res => {
                  console.log(res);

                  if (res.res.code == 10000){

                     var tip = res.res.msg;
                     if(!tip){
                        tip ="您的订单已核销，祝您使用愉快。";
                     }

                     if(res.body && res.body.url){
                        //跳转到 对应地址
                       // console.log("in body.url" +res.body.url)
                        this.$router.push({
                            path: res.body.url
                        });
                        return;
                     }
                     util.showToast(tip,3000);

                  }else{
                    var tip1 = res.res.msg;
                     if(!tip1){
                        if(res.res.code ==40009 ){
                            tip1 = "重复扫码";
                        }else{
                            tip1 = "扫码验证失败,请联系现场工作人员。";
                        }
                     }
                     util.showToast(tip1,3000);

                  }

            })
      },
      goToGetQRParkingCoupon(url){
        window.location.href = url;
      },

      toMessage() {
        if (!this.$store.state.common.userId) {
          this.$router.push({
            path: "/login",
            query: {
              Rurl: "/news"
            }
          });
        } else {
          this.$router.push({
            path: "/news"
          });
        }
      },
      toLogin() {
        this.$router.push({
          path: "/login",
          query: { Rurl: this.$route.fullPath }
        });
      },
      toCompanyList() {
        this.$router.push({
          path: `/companyList`
        });
      },
      toSetting() {
        if (!this.common.userId) {
          this.$router.push({
            path: "/login",
            query: { Rurl: this.$route.fullPath }
          });
        }else{
          this.$router.push({
            path: `/me/Setting`
          });
        }
      },
      getShareInfo(){
          let params = {
            url:window.location.href
          }
          if(this.$route.query.cityId){
            params.cityId = this.$route.query.cityId
          }else if(this.common.cityId)  {
            params.cityId = this.common.cityId
          }else{
            params.marketId = this.common.marketInfo.id || ''
          }
          getShareInfo(params).then(res=>{
             console.log("in getShareInfo")
            if(res.res.code === 10000){
              this.ShareInfo =res.body;
              wx.config({
                debug: false,
                appId: this.ShareInfo.appid, // 必填，公众号的唯一标识
                timestamp: this.ShareInfo.timestamp, // 必填，生成签名的时间戳，精确到秒
                nonceStr: this.ShareInfo.nonceStr, // 必填，生成签名的随机串
                signature: this.ShareInfo.signature, // 必填，签名
                jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','updateAppMessageShareData','updateTimelineShareData','chooseImage', 'uploadImage','downloadImage','chooseWXPay','checkJsApi', 'scanQRCode','hideMenuItems','hideOptionMenu','getLocation']
              })
              wx.ready(()=>{
                wx.hideMenuItems({
                  menuList: ["menuItem:openWithQQBrowser","menuItem:openWithSafari","menuItem:share:QZone","menuItem:share:weiboApp"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
                });
              })
            }
          })
     },

    },
    // created() {
    //     let u = window.navigator.userAgent;
    //     if(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 ){
    //       this.getShareInfo()
    //     }
    // }
  };
  </script>

  <style lang="less" scoped>
  @import "../../../assets/css/common.less";
  .body{
     width:100%;
     position:relative;
     flex-direction: column;

  }
  .my_userInfo{
    position:relative;
    .my_header_pic{
      width:100%;
      display: block;
      height:100%;
      position: absolute;
      top:0;
    }
    .my_user_buttom1{
    width: 100%;
    //  display: flex;
     position: relative;
     background-color: #FAFAFA;
     z-index:3;
     height: 28px;
  }

  }
  .top_box{
    flex-direction: row;
    justify-content: space-between;
    width: 750px;
    display: flex;
    margin-top:24px;
  }
  .topLeft{
    flex-direction: row;
    display: flex;
    align-items: center;
  }
  .topRight{
    flex-direction: row;
    display: flex;
  }
  .my_userMessage_right_icon {
    margin-left:48px;

    width: 120px;
    height: 120px;
    border-radius: 100%;
  }
  .my_userMessage_left_span1{

    margin-left: 24px;
    height:40px;
    font-size:28px;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:40px;
  }
  .TopView_saoma{
    margin-top: 28px;
    margin-right: 40px;
    width: 44px;
    height: 44px;
    img{
      display: block;
      width:44px;height:44px;
    }
  }
  .TopView_message{
    margin-top: 28px;
    margin-right: 40px;
    width: 44px;
    height: 44px;
    position: relative;
    .point {
      position: absolute;
      right: 0px;
      top:0px;
      display: block;
      width: 12px;
      height: 12px;
      border-radius: 100%;
      background: #f00;
    }
    img{
      display: block;
      width:44px;height:44px;
    }

  }

  .my_userMessage_left_div{
    margin-top: 20px;
    margin-left: 140px;
    width: 600px;
    display: flex;
    flex-direction: row;
  }
  .integral_left_div{
    display: flex;
    flex-direction: column;
  }
  .my_userMessage_left_icon{
    margin-left: 50px;
    margin-top: 25px;
    display: block;
    width: 32px;
    height: 32px;

}

.my_userMessage_left_span2{
    height:40px;
    font-size:28px;
    font-weight:400;
    color: #000000;
    line-height:40px;
    text-align: center;
  }
  .my_userMessage_left_span3{
      height:40px;
      font-size:28px;
      font-weight:400;
      line-height:40px;
      text-align: center;
      color: #00000080;
  }

  .companyDiv{
    width: 690px;
    height: 140px;
    margin-top: 40px;
    margin-left: 30px;
    border-radius: 9px;
    background: #D4B888;
    flex-direction: row;
    display: flex;
    .company_left{
        flex-direction: column;
        justify-content: center;
        height: 100%;
        display: flex;
        align-items: center;
        position: relative;
        .company_left_icon{
            width: 100px;
            height: 88px;
            margin-left: 40px;
        }
        .company_left_icon1{
            position: absolute;
            width: 37px;
            height: 21px;
            left: 75px;
            top:75px;

        }
    }
    .company_right{
        margin-left: 15px;
        flex-direction: column;
        display: flex;
        .company_right_div1{
            flex-direction:row;
            margin-top: 20px;
            align-items: center;
            .company_right_company_span{
                font-weight: 400;
                font-size: 30px;
                line-height: 42px;
                color: #ffffff;
                max-width: 480px;
            }
            .company_right_company_icon{
                margin-left: 20px;
                width: 14px;
                height: 22px;
            }
        }
        .company_right_div2{
            flex-direction:row;
            margin-top: 20px;
            align-items: center;
            .company_right_company_span{

                font-weight: 400;
                font-size: 28px;
                line-height: 40px;
                letter-spacing: 0%;
                color: #FFFFFFCC;
            }
        }
    }
  }


  .TopView{
    width: 100%;
    height: 100px;
    position: relative;
    top:0;
    z-index:3;
    overflow: hidden;
    display: flex;
    justify-content: flex-end;

  }
  .my_userMessage{
    display: flex;
    width: 100%;
    // height: 176px;
    position: relative;
    z-index:3;
    flex-direction: row;
  }
  .my_userMessage_left{
    margin-left: 40px;
    margin-top: 8px;
    width: 550px;
    flex-direction: row;

  }


  .my_userMessage_right{
      margin-top: 16px;
      display: flex;
      // background-color: red;
      .my_userMessage_right_icon {
        // display: block;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 100%;
      }
  }
  .my_user_company{
      //width: 100%;
      display: flex;
      position: relative;
      z-index:3;
      margin-top: 50px;
      flex-direction: row;
     .my_user_company_bg{
        margin-left: 28px;
        height:58px;
        display: flex;
        flex-direction: row;
        border-radius:29px;
        border:2px solid rgba(182,182,182,0.3);
        padding-left: 16px;
        padding-right: 16px;
        justify-content: center;
        align-items: center;
        .my_user_company_icon{
          width: 36px;
          height: 36px;
        }
        .my_user_company_img {
          //display: block;
          width: 32px;
          height: 32px;
        }
     }
  }
  .my_user_company_span {
        margin-top: 3px;
        height:40px;
        font-size:26px;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:40px;
        margin-left: 4px;
        margin-right: 4px;
        .textOver(350px);
  }
  .my_user_bottom{
    display: flex;
    position: relative;
    z-index:3;
    height: 80px;
  }
  .my_user_huiyuan{
     width: 100%;
     display: flex;
     position: relative;
     bottom:0;
     z-index:3;
     height: 88px;
    //  height: 120px ;
     .my_user_huiyuan_img{
      //  margin-top: 32px;
       margin-left: 28px;
       width: 694px;
       height: 88px;
     }
      .my_user_huiyuan_img1{
       border-top-left-radius: 20px;
       border-top-right-radius: 20px;
       margin-left: 28px;
       width: 694px;
       height: 88px;
     }
     .my_user_huiyuan_span{
       position: absolute;
        top: 22px;
        left: 112px;
        height:44px;
        font-size:32px;
        font-weight:500;
        color:rgba(106,118,132,1);
        line-height:44px;
     }
  }


  .my_user_box {
    width: 100%;
    position: relative;
    top:0;
    z-index:3;
    overflow: hidden;
    > img {
      display: block;
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 100%;
      margin: 0.8rem auto 0.2rem;
    }
    > span {
      display: block;
      font-size: 0.44rem;
      color: rgba(51, 51, 51, 1);
      line-height: 0.6rem;
      text-align: center;
      padding: 0 20px;
    }
    .my_saoma{
      position: absolute;
      left: 28px;
      top:28px;
      width: 44px;
      height: 44px;
      img{
        display: block;
        width:44px;height:44px;
      }
    }
    .my_message {
      width: 0.44rem;
      height: 0.44rem;
      padding: 0.28rem;
      position: absolute;
      top: 0;
      right: 0;
      .point {
        position: absolute;
        right: 28px;
        top: 28px;
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 100%;
        background: #f00;
      }
      img{
        display: block;
        width:44px;height:44px;
      }
    }
  }
  .unlogin {
     width: 100%;
    //  display: flex;
     position: relative;
     z-index:3;
    padding: 28px 0 60px;
    margin-bottom:28px;
    // background-color: red;
    p {
      text-align: center;
      margin-top: 15px;
      height: 40px;
      font-size: 28px;
      color: rgba(153, 153, 153, 1);
      line-height: 40px;
    }
  }
  .login_n {
    width: 100%;
    height: 198px;
    // margin-top:28px;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .login_y {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 34px 0 54px;
    height: 40px;
    margin-bottom:28px;
    span {
      display: block;
      font-size: 22px;
      color: @color17;
      padding: 0 6px;
      height: 32px;
      box-sizing: border-box;
      line-height: 32px;
      box-sizing: border-box;
      text-align: center;
      border-radius: 4px;
      border: 0.015rem solid rgba(23, 64, 218, 1);
      margin-right: 16px;
    }
    p {
      font-size: 28px;
      color: rgba(102, 102, 102, 1);
      line-height: 40px;
      margin-right: 4px;
      .textOver(350px);
    }
    img {
      display: block;
      width: 32px;
      height: 32px;
    }
  }
  </style>